import AnalyticsFitlers from './AnalyticsFitlers.component';

export default AnalyticsFitlers;